// NOTE: Do not import fabric in this file, https://www.notion.so/kittl/Importing-fabric-code-broke-website-build-13485ae43d478017a5fad936162ebfdd

export const shapeToolFeatureKey = 'shape-tool';
export const shapeToolPrefix = 'shapeTool:';
export const shapeTools = [
  `${shapeToolPrefix}star`,
  `${shapeToolPrefix}rectangle`,
  `${shapeToolPrefix}polygon`,
  `${shapeToolPrefix}ellipse`,
] as const;
export type ShapeObjectName = (typeof shapeTools)[number];

export const shapeToolPathMap: Record<ShapeObjectName, string> = {
  'shapeTool:star':
    'M50,2.44717l12.36068,35.5601l37.63932,0.76703l-30,22.74438l10.9017,36.03415l-30.9017,-21.5033l-30.9017,21.5033l10.9017,-36.03415l-30,-22.74438l37.63932,-0.76703z',
  'shapeTool:rectangle': 'M0,433.8v-433.8h433.8v433.8z',
  'shapeTool:polygon': 'M0,93.30127l50,-86.60254l50,86.60254z',
  'shapeTool:ellipse':
    'M0,223.18c0,-123.25891 99.92109,-223.18 223.18,-223.18c123.25891,0 223.18,99.92109 223.18,223.18c0,123.25891 -99.92109,223.18 -223.18,223.18c-123.25891,0 -223.18,-99.92109 -223.18,-223.18z',
};

/** Don't add /g flag in the regex as they make the regex stateful
 * If you have to, move the regex inside the function.
 */
const SHAPE_TOOL_SEGMENT_FEATURE_REGEX = /^shapeTool:(star|polygon)/;
const SHAPE_TOOL_FEATURE_REGEX = /^shapeTool:(star|polygon|rectangle|ellipse)/;

/**
 * Check whether the object is a shape tool object
 * @param objectName
 * @returns
 */
export function isShapeToolSegmentObject(
  objectName: string | undefined
): boolean {
  if (!objectName) {
    return false;
  }
  return SHAPE_TOOL_SEGMENT_FEATURE_REGEX.test(objectName);
}

/**
 * Check whether the object is supported for segments updating
 * @param objectName
 * @returns
 */
export function isShapeToolObject(objectName: string): boolean {
  return SHAPE_TOOL_FEATURE_REGEX.test(objectName);
}

export type ShapeType = 'star' | 'polygon' | 'rectangle' | 'ellipse';
export function getShapeType(objectName: string): ShapeType | null {
  const shapeType = objectName.split(':')[1] as ShapeType;
  if (!shapeType) {
    return null;
  }
  return shapeType;
}

// For shapes whose number of segments can be updated
export type ShapeSegmentType = 'star' | 'polygon';
export function getShapeSegmentType(
  objectName: string | undefined
): ShapeSegmentType | null {
  if (!objectName) {
    return null;
  }

  const shapeType = objectName.split(':')[1];

  if (shapeType === 'star' || shapeType === 'polygon') {
    return shapeType;
  }

  return null;
}
